import script from "./Params-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./Params-popup.vue?vue&type=script&setup=true&lang=js"

import "./Params-popup.vue?vue&type=style&index=0&id=e81d5e84&lang=scss&scoped=true"

import exportComponent from "/home/herman/Документи/Work/uhmi-web-maps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e81d5e84"]])

export default __exports__